import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ns-dashboard-api.kabilah.com';

export function createClass(name, tag) {
  return axios.post(`${BACKEND_URL}/api/classes`, { name, tag: tag || null });
}

export function renameClass(classId, name, tag) {
  return axios.put(`${BACKEND_URL}/api/classes/${classId}`, { name, tag: tag || null });
}

export function deleteClass(classId) {
  return axios.delete(`${BACKEND_URL}/api/classes/${classId}`);
}

export function addStudentToClass(classId, studentId) {
  return axios.post(`${BACKEND_URL}/api/classes/${classId}/students`, { studentId });
}

export function removeStudentFromClass(classId, studentId) {
  return axios.delete(`${BACKEND_URL}/api/classes/${classId}/students/${studentId}`);
}

export function addCaseToClass(classId, caseId) {
  return axios.post(`${BACKEND_URL}/api/classes/${classId}/cases`, { caseId });
}

export function removeCaseFromClass(classId, caseId) {
  return axios.delete(`${BACKEND_URL}/api/classes/${classId}/cases/${caseId}`);
}

// caseIds: full ordered array of case ids assigned to this class, after a drag reorder.
export function reorderClassCases(classId, caseIds) {
  return axios.put(`${BACKEND_URL}/api/classes/${classId}/cases/reorder`, { caseIds });
}

export function fetchClassCompletion(classId) {
  return axios.get(`${BACKEND_URL}/api/classes/${classId}/completion`);
}

// Class-wide, weekly-bucketed AACN sub-competency trend data (Developed /
// Developing / Not Yet Evidenced counts per sub-competency per week) for
// every sub-competency currently graded by this class's assigned cases.
// group: 'student' (real, non-demo students) or 'demo' (demo accounts only).
export function fetchClassIndicatorTrends(classId, group) {
  return axios.get(`${BACKEND_URL}/api/classes/${classId}/indicators/trends`, { params: { group } });
}

// Counts of this class's sessions by AI-grading state — no AI calls, cheap.
// -> { total, graded, pending, ungradable }
export function fetchClassGradingStatus(classId, requestingAdminEmail, signal) {
  return axios.get(`${BACKEND_URL}/api/classes/${classId}/grading-status`, {
    params: { requestingAdminEmail },
    signal,
  });
}

// Grades one small batch of this class's pending sessions (can take ~45s) and
// returns updated counts: { gradedNow, failedNow, total, graded, pending, ungradable }.
// Deliberately no `timeout`: each OpenAI call in the batch is allowed ~45s.
// Callers must run these strictly one at a time — see ClassGradingProgress.
export function gradeClassPendingSessions(classId, requestingAdminEmail, signal) {
  return axios.post(`${BACKEND_URL}/api/classes/${classId}/grade-pending`, { requestingAdminEmail }, { signal });
}
